import React, { FC } from 'react';
import { config, format } from '@/utils';
import style from './style.module.scss';

type TCarsItemPrice = {
  price: number;
  discountPrice: number;
  hasDiscount: boolean;
};

const CarsItemPrice: FC<TCarsItemPrice> = ({
  price,
  discountPrice,
  hasDiscount,
}) => {
  const { hidePrefixPrice } = config.all()

  return (
    <div className={style.wrap}>
      <div className={style.discountPrice}>
          {!hidePrefixPrice && <span>от</span>} {format.price(discountPrice)}
      </div>
      {hasDiscount && <div className={style.price}>{format.price(price)}</div>}
    </div>
  );
};

export default CarsItemPrice;
